import { render } from "./legoChipWrapper.vue?vue&type=template&id=95fe17aa"
import script from "./legoChipWrapper.vue?vue&type=script&lang=js"
export * from "./legoChipWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoChip/legoChipWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95fe17aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95fe17aa', __exports__)) {
    api.reload('95fe17aa', __exports__)
  }
  
  module.hot.accept("./legoChipWrapper.vue?vue&type=template&id=95fe17aa", () => {
    api.rerender('95fe17aa', render)
  })

}


export default __exports__